import angular from 'angular';

import OrderMonthSelectorComponent from './order-month-selector-component';

export default angular.module('order-month-selector', []).component('orderMonthSelector', new OrderMonthSelectorComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/order-month-selector/order-month-selector-module.js